<template>
    <trax-ui-ajax-simple-table 
        :id="id" :header="header" :header-color="headerColor"
        :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
    </trax-ui-ajax-simple-table>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-registration-leaners' },
            header: { default: 0 },
            headerColor: { default: 'primary' },
            facesFolder: {default: app_url},
            facesDefault: {default: 'polaris/img/lib/misc/avatar.jpg'}
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/registrations/'+data.registration.id,
                endpointParams: {
                    accessors: ['members']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learners',
                registration: data.registration,
                program_dashboard_routes: data.program_dashboard_routes,
                cols: [
                    {width: '50px'},
                    {},
                    {class: 'text-right'}
                ],
                learners : null,
                states : null,
                rows: [],
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.getStates();
        },
        
        updated: function() {
            $("#"+this.id+"-table .peity.donut").peity("donut");
        },
        
        methods: {
        
            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.setStates(response.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            setData(data) {
                var learners = data.data.members;
                learners.sort(function(a, b) {
                    if (a.lastname < b.lastname) return -1;
                    if (a.lastname > b.lastname) return 1;
                    return 0;
                });
                this.learners = learners;
                if (this.states) this.updateRows();
            },

            setStates(data) {
                this.states = data.data;
                if (this.learners) this.updateRows();
            },

            updateRows() {
                this.rows = [];
                for (var index in this.learners) {
                    var learner = this.learners[index];
                    this.rows.push([
                        this.picture(learner),
                        this.name(learner),
                        this.export(learner)
                    ]);
                }
            },

            picture(learner) {
                var src = learner.avatar ? learner.avatar : this.facesFolder + this.facesDefault;
                var html = '<img src="'+src+'" class="avatar">'
                return this.link(learner, html);
            }, 

            name(learner) {
                var html = learner.lastname + ' ' + learner.firstname;
                var entity = '';
                if (learner.entity) entity = learner.entity.name;
                if (learner.subentity) entity += ' / ' + learner.subentity.name;
                html += '<br><small>'+entity+'</small>';
                return this.link(learner, html);
            },

            export(learner) {
                var state = this.states[learner.id];
                if (!state) return '';
                return this.exportLink(learner);
            },

            link(learner, content) {
                var routes = this.program_dashboard_routes;
                var href = routes[this.registration.program.type]+'/registration/'+this.registration.id+'/learner/'+learner.id;
                return '<a href="'+href+'">'+content+'</a>';
            },

            exportLink(learner) {
                var routes = this.program_dashboard_routes;
                var href = routes[this.registration.program.type]+'/registration/'+this.registration.id+'/learner/'+learner.id+'/export';
                return '<a href="'+href+'" class=" btn btn-default btn-sm">'+this.lang.polaris.dashboard.export+'</a>';
            }

        }

    }
</script>
